const commonFn = {
    toast(type, msg) {
        bus.$message({
            message: msg,
            type: type
        })
    },
    notify(type, title, msg) {
        bus.$notify({
            title: title,
            message: msg,
            type: type
        });
    },
    trimTree(tree) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i].children.length == 0) {
                delete tree[i].children
            } else {
                this.trimTree(tree[i].children)
            }
        }
    },
    sortFilter(sort) {
        if (sort.prop) {
            return sort.prop + ' ' + sort.order.replace('descending', 'desc').replace('ascending', 'asc')
        } else {
            return ''
        }
    },
    // 标准日转化为年月日
    transformTime(date) {
        const d = new Date(date);
        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        let s = d.getDate();
        let h = d.getHours();
        let l = d.getMinutes();
        let k = d.getSeconds();
        if (m < 10) m = "0" + m;
        if (s < 10) s = "0" + s;
        if (h < 10) h = "0" + h;
        if (l < 10) l = "0" + l;
        if (k < 10) k = "0" + k;
        const datetime = y + "-" + m + "-" + s + ' ' + h + ":" + l + ":" + k;
        return datetime;
    },
}

export default commonFn